import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f32d2afc&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=f32d2afc&prod&lang=scss&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&id=f32d2afc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32d2afc",
  null
  
)

export default component.exports